:host {
  display: block;
  position: relative;
  float: calc(50%);
  width: 100%;
  height: 100%;
  background: var(--vp-primary-bg);
  --title-font: 'Inter', -apple-system, sans-serif;
  --description-font: 'SF Pro Text', system-ui, sans-serif;
  padding: 2px;
  border-radius: 4px;
}

.video-wrapper-container {
  display: flex;
  justify-content: space-between;
  height: 100%;
  gap: 1.5rem;
}

@media (max-width: 768px) {
  .video-wrapper-container {
    flex-direction: column;
    gap: 2rem;
  }
}
